import styled from 'styled-components';

const Headline = styled.h2`
  font-size: 1.8rem;
  font-weight: 700;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  p {
    line-height: 1.5;
  }

  p:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

const Email = styled.strong`
  /* Só quebra quando realmente não couber, e não no meio de qualquer letra:
     o objetivo é não estourar o modal com um endereço longo, não picotar um
     endereço que cabia. */
  overflow-wrap: anywhere;
`;

const Hint = styled.p`
  color: var(--ink-faint);
  font-size: 1.3rem;
`;

const ButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  margin-top: 2.5rem;

  button:not(:last-child) {
    margin-right: 2rem;
  }
`;

const modalStyles = {
  content: {
    padding: '40px 60px',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '500px',
  },
};

export { Headline, Content, Email, Hint, ButtonsContainer, modalStyles };
